export default "__VITE_ASSET__B0gOc0v9__"